export enum PollTypeEnum {
  Satisfaction = 0,
  Reservation = 1
}
